import {gsap} from "gsap";
import App from "@templates/App/App.js";
import Animation from "@templates/App/Animation.js";
import Popup from "@templates/Components/Popup/Popup.js";

const SpaceDetails = {
    init(el) {
        this.el = $('.spaceDetails');
        if (!this.el.length) return;

        this.buttonGallery = this.el.find(".gallery");
        this.buttonGallery = this.el.find(".gallery");
        this.detailsText = this.el.find("ul.text");

        const elms = this.el.find('.text, .numbers, .buttons');
        const from = {y: '40px', opacity: 0, duration: 0.3};
        const to = {y: 0, opacity: 1, duration: 0.3, stagger: 0.1};
        Animation.animate(elms, from, to, App.isMobile ? 0.2 : 0);
        Popup.initOpener(this.el);

        if (this.detailsText.children().length >= 10) {
            this.detailsText.addClass("long");
        }
    },
}
export default SpaceDetails;